"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BloodSignetEffectHandler = exports.BloodSignetEffectArgs = void 0;
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
const core_1 = require("../../vfx/core");
const LocationSelector_1 = require("../../vfx/LocationSelector");
class BloodSignetEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.BloodSignet;
        this.__typeName = "BloodSignet";
        this.name = "BloodSignet";
        this.harmful = true;
    }
}
exports.BloodSignetEffectArgs = BloodSignetEffectArgs;
BloodSignetEffectArgs.CustomText = "Mortally wounded...";
let BloodSignetEffectHandler = class BloodSignetEffectHandler {
    apply(sequence, container, state) {
        state.meta.ehIds = [
            container.registerEventHandlerScript(state.targetId, EventType_1.EventType.Healed, Schedule_1.Schedule.Unlimited, "Effect_BloodSignet_OnHealedOnTurnStarted", {
                createdBy: state.creatorId
            }),
            container.registerEventHandlerScript(state.targetId, EventType_1.EventType.TurnStarted, Schedule_1.Schedule.Unlimited, "Effect_BloodSignet_OnHealedOnTurnStarted", {
                createdBy: state.creatorId
            }),
        ];
        const bleedingVfx = new core_1.AuraVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(state.targetId, "feet"), "Bleeding");
        state.meta.vfxStepArgsId = bleedingVfx.id;
        sequence.push(bleedingVfx);
    }
    remove(sequence, container, state) {
        (state.meta.ehIds || []).forEach(ehId => container.cancelEventHandler(ehId));
        sequence.push(new core_1.CancelAuraVfxStepArgs(state.meta.vfxStepArgsId));
    }
};
BloodSignetEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.BloodSignet)
], BloodSignetEffectHandler);
exports.BloodSignetEffectHandler = BloodSignetEffectHandler;
